import { useState } from 'react'
import { db } from '../../utils/init-firebase';
import { updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import {
    Stack,
    Button,
    Flex,
    useToast,
    Alert,
    AlertTitle,
    AlertIcon,
    CloseButton,
    Spacer,
    FormControl  } from '@chakra-ui/react';
import { useHistory, useLocation } from 'react-router-dom'
import { Select } from "chakra-react-select";
import { useAuth } from '../../contexts/AuthContext';

  export default function AssignClaimClient({ status, loanOfficer, dateAdded, loanDetails, docID, showUndo, showView }) {
      const location = useLocation
    const toast = useToast()
    const { currentUser } = useAuth()
    const { users } = useAuth()

    const [selectedUser, setSelectedUser] = useState(null)

    const history = useHistory();
    const routeChange = (path) =>{ 
      history.push(`/in-progress/${path}`)
      toast.closeAll()
    }

    const handleUndo = async (docID) => {
        toast.closeAll()
        try{
            await updateDoc(doc(db, 'Clients', docID), {
                'Loan Officer': loanOfficer,
                'Loan Details': loanDetails,
                'LC': {
                    'Email': '',
                    'Name': '',
                    'uid': '',
                    'photoURL': ''
                },
                id: docID,
                'Status': 'New',
                'Last Edited By': {
                    Email: currentUser.email,
                    Name: currentUser.displayName,
                    photoURL: currentUser.photoURL,
                    uid: currentUser.uid
                }
            })
/*             if(!window.location.hostname === 'localhost'){
                await incrementSetupQueueCount()
            }       */      
            toast({
                duration: 3000,
                position: 'top',
                status: 'success',
                isClosable: true,
                title: loanDetails['First Name'] + ' ' + loanDetails['Last Name'] + ' unclaimed'
            })
        }
        catch(err){
            toast({
                title: 'Error',
                description: err,
                status: 'error',
                duration: 9000,
                isClosable: true,
              })
        }
    }

    const handleClaim = async (docID, LC) => {
        let alertTitle = null
        let assignee = null
        let assignedBy = null
        // if user is claiming file
        if(LC == null){
          assignee = {
            Email: currentUser.email,
            Name: currentUser.displayName,
            photoURL: currentUser.photoURL,
            uid: currentUser.uid
          }
          assignedBy = 'Claimed'
          alertTitle = loanDetails['First Name'] + ' ' + loanDetails['Last Name'] + ' has been claimed'
        }
        // if user is assigning file
        else {
          assignee = {
            Email: LC.email,
            Name: LC.label,
            photoURL: LC.photoURL,
            uid: LC.value
          }
          assignedBy = {
              Email: currentUser.email,
              Name: currentUser.displayName,
              photoURL: currentUser.photoURL,
              uid: currentUser.uid
          }
          alertTitle = `${loanDetails['First Name']} ${loanDetails['Last Name']}'s file has been assigned to ${LC.label}`
        }
        try{
            await updateDoc(doc(db, 'Clients', docID), {
                'LC': assignee,
                'Assigned By': assignedBy,
                id: docID,
                'Status': 'In Progress',
                'Date Claimed': serverTimestamp(),
                'Last Edited By': {
                    Email: currentUser.email,
                    Name: currentUser.displayName,
                    photoURL: currentUser.photoURL,
                    uid: currentUser.uid
                }
            })
            
            toast({
                duration: 5000,
                position: 'top',
                render: () => (
                  <Alert status="success" borderRadius={10}>
                      <Stack direction='column'>
                            <Stack direction='row'>
                                <AlertIcon/>
                                <AlertTitle> {alertTitle} </AlertTitle>
                            </Stack>
                            <Flex direction='row' justifyContent={'space-evenly'}>
                                {showUndo &&
                                <>
                                    <Button onClick={() => handleUndo(docID)} size='sm' variant='unstyled' colorScheme='green' > Undo </Button>
                                    <Spacer/>
                                </>
                                }
                                 {showView &&
                                    <Button onClick={() => routeChange(docID)} size='sm' colorScheme='blue' >View</Button>
                                 }
                            </Flex>
                        </Stack>
                        <CloseButton/>
                  </Alert>
                ),
              })
        }
        catch(err){
            toast({
                title: 'Error',
                description: err,
                status: 'error',
                duration: 9000,
                isClosable: true,
              })
        }

    }

    return (
        <>
        <Flex maxW={'300'} flexDirection={'column'} justifyContent={'center'}>
            <FormControl p={2}>
                <Select
                    options={users}
                    onChange={(e) => setSelectedUser(e)}
                    placeholder="Select LC"
                    closeMenuOnSelect={true}
                    selectedOptionColor="green"
                    classNamePrefix={'assign-client-select'}
                />
                </FormControl>
            <Stack mt={3} direction={'row'} spacing={4}>
            <Button
                disabled={!selectedUser}
                onClick={() => handleClaim(docID, selectedUser)}
                flex={1}
                fontSize={'sm'}
                rounded={'full'}
                _focus={{
                    bg: 'gray.200',
                }}>
                Assign
                </Button> 
                
                <Button
                onClick={() => handleClaim(docID)}
                flex={1}
                fontSize={'sm'}
                rounded={'full'}
                bg={'blue.400'}
                color={'white'}
                boxShadow={
                    '0px 1px 5px -5px rgb(66 153 225 / 48%), 0 7px 7px -5px rgb(66 153 225 / 43%)'
                }
                _hover={{
                    bg: 'blue.500',
                }}
                _focus={{
                    bg: 'blue.500',
                }}>
                
                Claim
                </Button>
        </Stack> 
       </Flex>
       </>
    );
  }